import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AdaptLinkDisabledModule } from "@common/ux/link-disabled/link-disabled.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { DxSelectBoxModule } from "devextreme-angular";
import { AdaptLabellingModule } from "../../labelling/labeling.module";
import { LinkTeamDashboardComponent } from "./link-team-dashboard/link-team-dashboard.component";
import { SelectTeamComponent } from "./select-team/select-team.component";
import { TeamInactiveBadgeComponent } from "./team-inactive-badge/team-inactive-badge.component";
import { TeamPrivateIconComponent } from "./team-private-icon/team-private-icon.component";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        AdaptTooltipModule,
        AdaptLabellingModule,
        DxSelectBoxModule,
        AdaptLinkDisabledModule,
    ],
    exports: [
        TeamInactiveBadgeComponent,
        LinkTeamDashboardComponent,
        TeamPrivateIconComponent,
        SelectTeamComponent,
    ],
    declarations: [
        TeamInactiveBadgeComponent,
        LinkTeamDashboardComponent,
        TeamPrivateIconComponent,
        SelectTeamComponent,
    ],
})
export class AdaptTeamDashboardSharedModule { }
